import React from "react";

import { Section } from "../ui/atoms/section";
import { useTranslation } from "react-i18next";
import { ListPedestrianDevices } from "../ui/molecules/list-pedestrian-devices";
import { createUuid } from "../utils/uuid";
import sizes from "../ui/sizes.scss";
import { FusionLayout } from "@/parts/fusion-layout";
import { Stack } from "@fluentui/react";
import { ListCommandButtonsPedestrianDevices } from "../ui/organisms/list-command-buttons-pedestrian-devices";
import { observer } from "mobx-react";

export const PagePedestrianDevices = observer((): JSX.Element => {
    const { t } = useTranslation();
    const pedestrianDeviceListStateId = createUuid();

    return (
        <FusionLayout breadcrumb={t("page.pedestrianDevices.title")} classic>
            <Section fill>
                <ListPedestrianDevices
                    commandBar={
                        <Stack horizontal style={{ alignItems: "center" }}>
                            <ListCommandButtonsPedestrianDevices
                                listStateId={pedestrianDeviceListStateId}
                            />
                        </Stack>
                    }
                    listStateId={pedestrianDeviceListStateId}
                    maxHeight={`${sizes.listMaxHeight}`}
                />
            </Section>
        </FusionLayout>
    );
});
